var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrintIconNoframe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6987 6.23984V1.55996H6.30132V6.23984H4.87665V0H19.1234V6.23984H17.6987ZM19.9995 11.6997C20.4032 11.6997 20.7418 11.5505 21.0153 11.252C21.2888 10.9535 21.4251 10.5828 21.4242 10.1397C21.4242 9.69776 21.2879 9.32753 21.0153 9.02905C20.7427 8.73058 20.4041 8.58083 19.9995 8.57979C19.5959 8.57979 19.2577 8.72954 18.9852 9.02905C18.7126 9.32857 18.5758 9.6988 18.5749 10.1397C18.5749 10.5817 18.7116 10.9525 18.9852 11.252C19.2587 11.5515 19.5968 11.7007 19.9995 11.6997ZM17.6987 22.44V15.3609H6.30132V22.44H17.6987ZM19.1234 24H4.87665V17.7602H0V9.35977C0 8.47579 0.274011 7.73481 0.822035 7.13682C1.37006 6.53884 2.04583 6.23984 2.84934 6.23984H21.1507C21.958 6.23984 22.6347 6.53884 23.1808 7.13682C23.7269 7.73481 24 8.47579 24 9.35977V17.7602H19.1234V24ZM22.5753 16.2002V9.35977C22.5753 8.91778 22.439 8.54755 22.1664 8.24907C21.8939 7.9506 21.5553 7.80084 21.1507 7.7998H2.84934C2.44568 7.7998 2.10709 7.94956 1.83355 8.24907C1.56001 8.54859 1.42372 8.91882 1.42467 9.35977V16.2002H4.87665V13.801H19.1234V16.2002H22.5753Z",
    fill: "#2A3C50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIconNoframe);
export default __webpack_public_path__ + "static/media/print-icon-noframe.e89a546f53aa8408f590e46889f0af01.svg";
export { ForwardRef as ReactComponent };